import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/admin/add-client/[id]/company-information/page";

export const Route = createFileRoute(
  "/admin/add-client/$clientId/company-information",
)({
  component: Page,
});
